import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '../../mocks/categories';
import { productsSectionTexts } from '../../mocks/productsSectionTexts';
import FeaturedProducts from './components/FeaturedProducts';
import ProductSearch from '../../components/feature/ProductSearch';

export default function HomePage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [currentOffer, setCurrentOffer] = useState(0);
  const [formData, setFormData] = useState({
    nombre: '',
    negocio: '',
    comuna: '',
    productos: '',
    volumen: '',
    telefono: '',
    email: ''
  });
  const [formStatus, setFormStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');

  const offers = [
    {
      type: 'Oferta Especial',
      title: 'Energética Score',
      description: '¡Oferta Imperdible!',
      badge: 'HOY',
      price: '$19.930',
      originalPrice: '$20.640',
      unitPrice: '$830',
      priceLabel: 'Pack 24 un.',
      video: 'https://res.cloudinary.com/dsspl56oi/video/upload/v1770399119/Create_a_video_202602061424_spuxf_wzws0w.mp4',
      gradient: 'from-lime-500/90 via-green-600/80 to-transparent',
      isVideo: true
    },
    {
      type: 'Oferta Especial',
      title: 'Azúcar Iansa 1 kg',
      description: '¡Oferta Imperdible!',
      badge: 'SEMANA',
      price: '$27.000',
      originalPrice: '$29.000',
      unitPrice: '$1.350',
      priceLabel: 'Pack 20 un.',
      video: 'https://res.cloudinary.com/dsspl56oi/video/upload/v1770493257/Sport_publicitario_co_202602071640_tbi4f_obeohe.mp4',
      gradient: 'from-yellow-500/90 via-orange-600/80 to-transparent',
      isVideo: true
    },
    {
      type: 'Oferta Especial',
      title: 'Latas CCU',
      description: '¡Oferta Imperdible!',
      badge: 'MES',
      price: '$3.510',
      originalPrice: '$3.600',
      unitPrice: '$585',
      priceLabel: 'pack 6 un.',
      video: 'https://res.cloudinary.com/dsspl56oi/video/upload/v1770408345/Use_this_reference_202602061705_r2gk3_gutw7e.mp4',
      gradient: 'from-lime-400/90 via-emerald-600/80 to-transparent',
      isVideo: true
    },
    {
      type: 'Oferta Especial',
      title: 'Swan 22 Metros',
      description: '¡Oferta Imperdible!',
      badge: 'ESPECIAL',
      price: '$8.900',
      originalPrice: '$11.040',
      unitPrice: '$185',
      priceLabel: 'Pack 46 rollos',
      video: 'https://res.cloudinary.com/dsspl56oi/video/upload/v1770492529/Cinematic_and_realistic_202602071624_ulwnd_zcbbcw.mp4',
      gradient: 'from-green-500/90 via-lime-600/80 to-transparent',
      isVideo: true
    }
  ];

  // Detectar scroll para navbar
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Carrusel automático de ofertas
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentOffer((prev) => (prev + 1) % offers.length);
    }, 8000);
    return () => clearInterval(interval);
  }, [offers.length]);

  const handleWhatsApp = () => {
    window.open('https://wa.me/56912345678?text=Hola,%20quiero%20cotizar%20productos%20para%20mi%20negocio', '_blank');
  };

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormStatus('sending');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d62l2f25dngp5anjaip0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setFormStatus('success');
        setFormData({
          nombre: '',
          negocio: '',
          comuna: '',
          productos: '',
          volumen: '',
          telefono: '',
          email: ''
        });
        setTimeout(() => setFormStatus('idle'), 5000);
      } else {
        setFormStatus('error');
        setTimeout(() => setFormStatus('idle'), 5000);
      }
    } catch (error) {
      setFormStatus('error');
      setTimeout(() => setFormStatus('idle'), 5000);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-black">
      {/* Navbar */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-black/95 shadow-lg shadow-lime-500/10' : 'bg-black/20 backdrop-blur-md'}`}>
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <div className="flex items-center">
              <img src="https://static.readdy.ai/image/4161236c74d0ec9b097d0882ccdfeefd/9a712df9f4520947901c304b55b2e414.png" alt="ACI Distribución" className="h-12 w-auto" />
              <div className="ml-3 hidden lg:block">
                <p className={`text-xs ${isScrolled ? 'text-lime-400' : 'text-lime-300'}`}>Confianza que se distribuye</p>
              </div>
            </div>

            {/* Desktop Menu */}
            <div className="hidden lg:flex items-center space-x-8">
              <a href="#inicio" className={`text-sm font-medium transition-colors ${isScrolled ? 'text-gray-300 hover:text-lime-400' : 'text-white hover:text-lime-300'}`}>Inicio</a>
              <a href="#servicios" className={`text-sm font-medium transition-colors ${isScrolled ? 'text-gray-300 hover:text-lime-400' : 'text-white hover:text-lime-300'}`}>Servicios</a>
              <a href="#productos" className={`text-sm font-medium transition-colors ${isScrolled ? 'text-gray-300 hover:text-lime-400' : 'text-white hover:text-lime-300'}`}>Productos</a>
              <a href="#nosotros" className={`text-sm font-medium transition-colors ${isScrolled ? 'text-gray-300 hover:text-lime-400' : 'text-white hover:text-lime-300'}`}>Nosotros</a>
              <a href="#contacto" className={`text-sm font-medium transition-colors ${isScrolled ? 'text-gray-300 hover:text-lime-400' : 'text-white hover:text-lime-300'}`}>Contacto</a>
            </div>

            {/* CTA Button */}
            <button onClick={handleWhatsApp} className={`hidden lg:block px-6 py-2.5 rounded-lg text-sm font-semibold transition-all whitespace-nowrap border-2 border-lime-400 text-lime-400 hover:bg-lime-400 hover:text-black`}>
              Cotizar Ahora
            </button>

            {/* Mobile Menu Button */}
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="lg:hidden p-2">
              <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-lime-400' : 'text-white'}`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden bg-black/95 border-t border-lime-500/20">
            <div className="px-6 py-4 space-y-3">
              <a href="#inicio" className="block text-gray-300 hover:text-lime-400 font-medium">Inicio</a>
              <a href="#servicios" className="block text-gray-300 hover:text-lime-400 font-medium">Servicios</a>
              <a href="#productos" className="block text-gray-300 hover:text-lime-400 font-medium">Productos</a>
              <a href="#nosotros" className="block text-gray-300 hover:text-lime-400 font-medium">Nosotros</a>
              <a href="#contacto" className="block text-gray-300 hover:text-lime-400 font-medium">Contacto</a>
              <button onClick={handleWhatsApp} className="w-full mt-4 px-6 py-3 bg-lime-500 text-black rounded-lg font-semibold whitespace-nowrap">
                Cotizar Ahora
              </button>
            </div>
          </div>
        )}
      </nav>

      {/* WhatsApp Floating Button */}
      <button onClick={handleWhatsApp} className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-lime-500 rounded-full shadow-2xl shadow-lime-500/50 flex items-center justify-center hover:scale-110 transition-transform group">
        <i className="ri-whatsapp-line text-black text-3xl"></i>
        <span className="absolute bottom-full right-0 mb-2 px-3 py-1.5 bg-lime-500 text-black text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap font-semibold">
          Cotiza por WhatsApp
        </span>
      </button>

      {/* Hero Section */}
      <section id="inicio" className="relative h-screen flex items-center justify-center overflow-hidden pt-20">
        <div className="absolute inset-0">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-full object-cover object-center"
          >
            <source src="https://res.cloudinary.com/dsspl56oi/video/upload/v1770406665/aaaaa_pth05e.mp4" type="video/mp4" />
          </video>
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-lime-500/10 via-transparent to-lime-500/10"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 text-center w-full">
          <h1 className="text-5xl lg:text-7xl font-black text-white mb-6 leading-tight">
            Distribución para tu negocio,<br /><span className="text-lime-400">con respaldo</span>
          </h1>
          <p className="text-xl lg:text-2xl text-gray-300 mb-10 max-w-3xl mx-auto">
            Bebidas y abarrotes para minimarkets y empresas. Despacho coordinado.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button onClick={handleWhatsApp} className="px-8 py-4 bg-lime-500 text-black rounded-lg font-bold text-lg hover:bg-lime-400 transition-colors flex items-center justify-center gap-2 whitespace-nowrap shadow-lg shadow-lime-500/30">
              <i className="ri-whatsapp-line text-2xl"></i>
              Cotizar por WhatsApp
            </button>
            <a href="#contacto" className="px-8 py-4 border-2 border-lime-400 text-lime-400 rounded-lg font-semibold text-lg hover:bg-lime-400 hover:text-black transition-colors whitespace-nowrap">
              Solicitar Catálogo
            </a>
          </div>
        </div>
      </section>

      {/* Beneficios Section */}
      <section className="py-24 bg-zinc-950">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <h2 className="text-4xl lg:text-5xl font-black text-lime-400 text-center mb-16">
            ¿Por qué elegir ACI?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: 'ri-price-tag-3-line',
                title: 'Precios Competitivos',
                description: 'Tarifas mayoristas diseñadas para maximizar tu rentabilidad y mantener tu negocio competitivo.'
              },
              {
                icon: 'ri-refresh-line',
                title: 'Continuidad y Disponibilidad',
                description: 'Stock permanente de productos esenciales para que nunca te quedes sin inventario.'
              },
              {
                icon: 'ri-truck-line',
                title: 'Despacho Coordinado',
                description: 'Entregas programadas según tus necesidades, con seguimiento en tiempo real.'
              },
              {
                icon: 'ri-customer-service-2-line',
                title: 'Postventa y Seguimiento',
                description: 'Atención personalizada y seguimiento continuo para resolver cualquier consulta.'
              }
            ].map((benefit, index) => (
              <div key={index} className="border border-lime-500/30 rounded-xl p-10 hover:border-lime-400 hover:shadow-xl hover:shadow-lime-500/10 transition-all group bg-black/50">
                <div className="w-20 h-20 bg-lime-500/20 rounded-full flex items-center justify-center mb-6 group-hover:bg-lime-500/30 transition-colors">
                  <i className={`${benefit.icon} text-4xl text-lime-400`}></i>
                </div>
                <h3 className="text-xl font-semibold text-white mb-3">{benefit.title}</h3>
                <p className="text-gray-400 leading-relaxed">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Video Ofertas Section */}
      <section className="relative h-[50vh] w-full overflow-hidden">
        <div className="absolute inset-0">
          {offers.map((offer, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === currentOffer ? 'opacity-100' : 'opacity-0'
              }`}
            >
              {offer.isVideo ? (
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="w-full h-full object-cover"
                >
                  <source src={offer.video} type="video/mp4" />
                </video>
              ) : (
                <img
                  src={offer.video}
                  alt={offer.title}
                  className="w-full h-full object-cover"
                />
              )}
            </div>
          ))}
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent"></div>
        </div>

        <div className="relative z-10 h-full max-w-7xl mx-auto px-6 lg:px-12 flex items-center">
          <div className="w-full">
            {offers.map((offer, index) => (
              <div
                key={index}
                className={`transition-all duration-700 ease-in-out ${
                  index === currentOffer
                    ? 'opacity-100 translate-y-0'
                    : 'opacity-0 translate-y-8 absolute pointer-events-none'
                }`}
              >
                <div className="flex items-center justify-between w-full">
                  <div className="max-w-xl">
                    {/* Badge animado */}
                    <div className="inline-flex items-center gap-3 mb-4">
                      <span className="px-3 py-1.5 bg-lime-500/20 backdrop-blur-sm text-lime-400 rounded-full text-xs font-bold uppercase tracking-wider animate-pulse border border-lime-500/50">
                        {offer.type}
                      </span>
                    </div>

                    {/* Título */}
                    <h2 className="text-4xl lg:text-5xl font-black text-white mb-3 leading-tight drop-shadow-lg">
                      {offer.title}
                    </h2>

                    {/* Descripción */}
                    <p className="text-lg lg:text-xl text-gray-200 mb-6 max-w-md leading-relaxed">
                      {offer.description}
                    </p>

                    {/* Botones */}
                    <div className="flex flex-col sm:flex-row gap-3">
                      <button
                        onClick={handleWhatsApp}
                        className="px-6 py-3 bg-lime-500 text-black rounded-lg font-bold text-base hover:bg-lime-400 transition-all hover:scale-105 shadow-xl shadow-lime-500/30 inline-flex items-center justify-center gap-2 whitespace-nowrap"
                      >
                        <i className="ri-whatsapp-line text-xl"></i>
                        ¡Quiero esta Oferta!
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {/* Cuadro de Precio - Posición fija en la derecha */}
            <div className="hidden lg:block absolute top-1/2 right-12 transform -translate-y-1/2">
              <div className="relative w-[280px] h-[300px]">
                {offers.map((offer, index) => (
                  <div
                    key={index}
                    className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${
                      index === currentOffer
                        ? 'opacity-100'
                        : 'opacity-0 pointer-events-none'
                    }`}
                  >
                    <div className="bg-black/60 backdrop-blur-md border-2 border-lime-400 rounded-2xl overflow-hidden shadow-2xl shadow-lime-500/20 h-full flex flex-col">
                      {/* Badge del Pack - Integrado arriba */}
                      <div className="bg-lime-500 py-3 px-4">
                        <p className="text-black text-lg font-black text-center uppercase tracking-wide">{offer.priceLabel}</p>
                      </div>
                      
                      {/* Contenido del precio */}
                      <div className="flex-1 flex flex-col justify-center p-6 text-center">
                        <div className="mb-4 pb-4 border-b border-lime-500/30">
                          <p className="text-gray-400 text-xs mb-1">Precio unitario (ref.):</p>
                          <p className="text-white text-xl font-bold">{offer.unitPrice}</p>
                        </div>
                        <p className="text-gray-400 text-base line-through mb-1">{offer.originalPrice}</p>
                        <p className="text-white text-5xl font-black mb-5 leading-none">{offer.price}</p>
                        <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-lime-500 rounded-full mx-auto">
                          <i className="ri-discount-percent-line text-black text-lg"></i>
                          <span className="text-black text-base font-bold">Ahorra</span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Indicadores y navegación */}
            <div className="absolute bottom-6 left-6 lg:left-12 right-6 lg:right-12 flex items-center justify-between">
              {/* Indicadores de progreso */}
              <div className="flex gap-2">
                {offers.map((offer, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentOffer(index)}
                    className={`relative h-1.5 rounded-full transition-all duration-500 cursor-pointer overflow-hidden ${
                      index === currentOffer ? 'w-16 bg-lime-500/30' : 'w-2.5 bg-lime-500/30 hover:bg-lime-500/50'
                    }`}
                  >
                    {index === currentOffer && (
                      <div
                        className="absolute inset-y-0 left-0 bg-lime-400 rounded-full animate-progress"
                        style={{ animation: 'progress 5s linear infinite' }}
                      ></div>
                    )}
                  </button>
                ))}
              </div>

              {/* Botones de navegación */}
              <div className="flex gap-2">
                <button
                  onClick={() => setCurrentOffer((prev) => (prev - 1 + offers.length) % offers.length)}
                  className="w-11 h-11 bg-black/40 backdrop-blur-sm hover:bg-lime-500/30 border border-lime-500/30 rounded-full flex items-center justify-center text-lime-400 transition-all hover:scale-110 cursor-pointer"
                >
                  <i className="ri-arrow-left-s-line text-2xl"></i>
                </button>
                <button
                  onClick={() => setCurrentOffer((prev) => (prev + 1) % offers.length)}
                  className="w-11 h-11 bg-black/40 backdrop-blur-sm hover:bg-lime-500/30 border border-lime-500/30 rounded-full flex items-center justify-center text-lime-400 transition-all hover:scale-110 cursor-pointer"
                >
                  <i className="ri-arrow-right-s-line text-2xl"></i>
                </button>
              </div>
            </div>

            {/* Contador de ofertas */}
            <div className="absolute top-6 right-6 lg:right-12">
              <div className="flex items-center gap-2 px-3 py-1.5 bg-black/40 backdrop-blur-sm rounded-full border border-lime-500/30">
                <i className="ri-fire-fill text-lime-400 text-lg"></i>
                <span className="text-lime-400 font-semibold text-sm">
                  {currentOffer + 1} / {offers.length} Ofertas
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Buscador de Productos */}
      <ProductSearch />

      {/* Productos Section */}
      <section id="productos" className="py-28 bg-zinc-900">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-12">
            <div>
              <h2 className="text-4xl lg:text-5xl font-black text-white mb-3">{productsSectionTexts.title} <span className="text-lime-400">{productsSectionTexts.titleHighlight}</span></h2>
              <p className="text-lg text-gray-400">{productsSectionTexts.subtitle}</p>
            </div>
            <button onClick={handleWhatsApp} className="mt-6 lg:mt-0 px-6 py-3 bg-lime-500 text-black rounded-lg font-semibold hover:bg-lime-400 transition-colors flex items-center gap-2 whitespace-nowrap">
              <i className={productsSectionTexts.buttonIcon}></i>
              {productsSectionTexts.buttonText}
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {categories.map((category, index) => {
              const isEnergeticas = category.name === 'Energética Score';
              const isAbarrotes = category.name === 'Abarrotes';
              const isAgua = category.name === 'Agua';
              const isGaseosas = category.name === 'Gaseosas';
              const isPapelHigienico = category.name === 'Papel Higiénico y Toalla Nova';
              const isIsotonicas = category.name === 'Bebidas Isotónicas';
              const shouldLink = isEnergeticas || isAbarrotes || isAgua || isGaseosas || isPapelHigienico || isIsotonicas;
              const CardWrapper = shouldLink ? Link : 'div';
              const cardProps = isEnergeticas ? { to: '/energeticas' } : isAbarrotes ? { to: '/abarrotes' } : isAgua ? { to: '/agua' } : isGaseosas ? { to: '/gaseosas' } : isPapelHigienico ? { to: '/papel-higienico' } : isIsotonicas ? { to: '/isotonicas' } : {};
              
              return (
                <CardWrapper 
                  key={index} 
                  {...cardProps}
                  className="relative rounded-2xl overflow-hidden group cursor-pointer h-80 border border-lime-500/20 hover:border-lime-400/50 transition-all block" 
                  data-product-shop
                >
                  <img src={category.image} alt={category.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h3 className="text-2xl font-bold text-white mb-1">{category.name}</h3>
                  </div>
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    {shouldLink ? (
                      <span className="px-6 py-3 bg-lime-500 text-black rounded-lg font-semibold whitespace-nowrap">
                        Ver Catálogo
                      </span>
                    ) : (
                      <button onClick={handleWhatsApp} className="px-6 py-3 bg-lime-500 text-black rounded-lg font-semibold hover:bg-lime-400 transition-colors whitespace-nowrap">
                        {productsSectionTexts.categoryButtonText}
                      </button>
                    )}
                  </div>
                </CardWrapper>
              );
            })}
          </div>

          <div className="text-center mt-12">
            <button onClick={handleWhatsApp} className="px-8 py-4 bg-lime-500 text-black rounded-lg font-bold text-lg hover:bg-lime-400 transition-colors inline-flex items-center gap-2 whitespace-nowrap shadow-lg shadow-lime-500/30">
              <i className={`${productsSectionTexts.bottomButtonIcon} text-2xl`}></i>
              {productsSectionTexts.bottomButtonText}
            </button>
          </div>
        </div>
      </section>

      {/* Productos Destacados */}
      <FeaturedProducts />

      {/* Proceso Section */}
      <section className="py-24 bg-black">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <h2 className="text-4xl lg:text-5xl font-black text-white text-center mb-20">
            Cómo <span className="text-lime-400">Trabajamos</span> Contigo
          </h2>

          <div className="relative">
            {/* Línea horizontal */}
            <div className="hidden lg:block absolute top-16 left-0 right-0 h-1 bg-gradient-to-r from-lime-500 via-lime-400 to-lime-500" style={{ left: '10%', right: '10%' }}></div>

            <div className="grid grid-cols-1 lg:grid-cols-4 gap-12 lg:gap-8">
              {[
                {
                  number: '1',
                  icon: 'ri-phone-line',
                  title: 'Contacto',
                  description: 'Escríbenos por WhatsApp o completa el formulario'
                },
                {
                  number: '2',
                  icon: 'ri-file-list-3-line',
                  title: 'Catálogo',
                  description: 'Recibe nuestra lista de productos y precios'
                },
                {
                  number: '3',
                  icon: 'ri-shopping-cart-line',
                  title: 'Pedido',
                  description: 'Confirma tu orden y coordina el despacho'
                },
                {
                  number: '4',
                  icon: 'ri-truck-line',
                  title: 'Despacho y Seguimiento',
                  description: 'Recibe tu pedido con seguimiento en tiempo real'
                }
              ].map((step, index) => (
                <div key={index} className="flex flex-col items-center text-center relative">
                  <div className="w-32 h-32 rounded-full border-4 border-lime-500 bg-black flex items-center justify-center mb-6 relative z-10 shadow-lg shadow-lime-500/30">
                    <div className="flex flex-col items-center">
                      <span className="text-4xl font-black text-lime-400 mb-1">{step.number}</span>
                      <i className={`${step.icon} text-2xl text-lime-400`}></i>
                    </div>
                  </div>
                  <h3 className="text-xl font-semibold text-white mb-2">{step.title}</h3>
                  <p className="text-gray-400 text-sm max-w-[200px]">{step.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Servicios Section */}
      <section id="servicios" className="py-24 bg-zinc-950">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <h2 className="text-4xl lg:text-5xl font-black text-white text-center mb-16">
            Nuestros <span className="text-lime-400">Servicios</span>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {[
              {
                icon: 'ri-store-2-line',
                title: 'Distribución Mayorista B2B',
                description: 'Abastecimiento especializado para minimarkets, botillerías, almacenes y distribuidoras. Precios competitivos y condiciones comerciales flexibles.'
              },
              {
                icon: 'ri-repeat-line',
                title: 'Abastecimiento Recurrente',
                description: 'Programa tus pedidos regulares y asegura la continuidad de tu inventario. Coordinamos entregas periódicas según tus necesidades.'
              },
              {
                icon: 'ri-route-line',
                title: 'Coordinación de Rutas y Despacho',
                description: 'Logística eficiente con rutas optimizadas. Despacho directo en RM y coordinación para regiones con seguimiento completo.'
              },
              {
                icon: 'ri-file-list-2-line',
                title: 'Postventa y Estados de Entrega',
                description: 'Seguimiento detallado de tu pedido: por despachar, en ruta, entregado. Atención personalizada para resolver cualquier consulta.'
              }
            ].map((service, index) => (
              <div key={index} className="bg-black/50 border border-lime-500/20 rounded-xl p-8 hover:border-lime-400/50 hover:shadow-lg hover:shadow-lime-500/10 transition-all">
                <div className="w-16 h-16 bg-lime-500 rounded-lg flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-3xl text-black`}></i>
                </div>
                <h3 className="text-2xl font-semibold text-white mb-4">{service.title}</h3>
                <p className="text-gray-400 leading-relaxed">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Cobertura Section */}
      <section className="py-20 bg-gradient-to-r from-lime-600 via-lime-500 to-green-500">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="relative h-[500px] flex items-center justify-center">
              <div className="absolute inset-0 bg-black/20 rounded-3xl"></div>
              <div className="relative z-10 flex items-center justify-center h-full">
                <div className="relative">
                  <img 
                    src="https://static.readdy.ai/image/4161236c74d0ec9b097d0882ccdfeefd/5c0c26ca5ed734e616d9e12beee9b9d8.png" 
                    alt="Mapa Chile" 
                    className="h-[450px] w-auto drop-shadow-2xl" 
                  />
                  <div className="absolute top-[35%] left-1/2 transform -translate-x-1/2 z-20">
                    <div className="relative">
                      <div className="w-6 h-6 bg-black rounded-full animate-pulse shadow-2xl border-4 border-lime-300"></div>
                      <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 bg-black px-3 py-1.5 rounded-lg whitespace-nowrap">
                        <span className="text-lime-400 font-bold text-sm">Santiago</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-black">
              <h2 className="text-4xl lg:text-5xl font-black mb-8">Cobertura Nacional</h2>
              <div className="space-y-4 mb-8">
                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 bg-black rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-lime-400 text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-1">Región Metropolitana</h3>
                    <p className="text-black/80">Despacho directo con rutas optimizadas</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 bg-black rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-lime-400 text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-1">Otras Regiones</h3>
                    <p className="text-black/80">Coordinación logística a nivel nacional</p>
                  </div>
                </div>
              </div>
              <button onClick={handleWhatsApp} className="px-8 py-4 bg-black text-lime-400 rounded-lg font-bold text-lg hover:bg-zinc-900 transition-colors whitespace-nowrap">
                Consulta tu Zona
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Confianza Section */}
      <section className="py-16 bg-black">
        <div className="max-w-6xl mx-auto px-6 lg:px-12">
          <div className="flex flex-col lg:flex-row items-center justify-center gap-12 lg:gap-20">
            <div className="flex flex-col items-center text-center">
              <div className="w-12 h-12 flex items-center justify-center mb-4">
                <i className="ri-shield-check-line text-4xl text-lime-400"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-1">Empresa Formal</h3>
              <p className="text-sm text-gray-400">Abarca y Castillo Distribución SpA</p>
            </div>

            <div className="hidden lg:block w-px h-16 bg-lime-500/30"></div>

            <div className="flex flex-col items-center text-center">
              <div className="w-12 h-12 flex items-center justify-center mb-4">
                <img src="https://static.readdy.ai/image/4161236c74d0ec9b097d0882ccdfeefd/14562121d245bf4b22f6b6a4ccbfad34.png" alt="Atención B2B" className="w-12 h-12 object-contain" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-1">Atención B2B</h3>
              <p className="text-sm text-gray-400">Especialistas en negocios</p>
            </div>

            <div className="hidden lg:block w-px h-16 bg-lime-500/30"></div>

            <div className="flex flex-col items-center text-center">
              <div className="w-12 h-12 flex items-center justify-center mb-4">
                <i className="ri-line-chart-line text-4xl text-lime-400"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-1">Relación a Largo Plazo</h3>
              <p className="text-sm text-gray-400">Compromiso con tu crecimiento</p>
            </div>
          </div>
        </div>
      </section>

      {/* Nosotros Section */}
      <section id="nosotros" className="py-24 bg-black">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl lg:text-5xl font-black text-white mb-6">Sobre <span className="text-lime-400">ACI Distribución</span></h2>
              <p className="text-lg text-gray-300 leading-relaxed mb-6">
                Somos <strong className="text-lime-400">Abarca y Castillo Distribución SpA</strong>, una empresa chilena dedicada a la distribución mayorista de bebidas y abarrotes para negocios B2B.
              </p>
              <p className="text-lg text-gray-300 leading-relaxed mb-6">
                Nacimos con el propósito de ser un socio confiable para minimarkets, botillerías, almacenes y distribuidoras, entregando productos de calidad con un servicio cercano y profesional.
              </p>
              <p className="text-lg text-gray-300 leading-relaxed mb-8">
                Nuestra operación comenzó en la Región Metropolitana y hoy coordinamos despachos a nivel nacional, manteniendo siempre nuestro compromiso con la continuidad, la transparencia y el servicio de excelencia.
              </p>

              <div className="space-y-4">
                <h3 className="text-2xl font-bold text-lime-400 mb-4">Nuestros Valores</h3>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-lime-500 mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-white">Compromiso</h4>
                    <p className="text-gray-400">Cumplimos lo que prometemos, siempre.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-lime-500 mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-white">Orden</h4>
                    <p className="text-gray-400">Procesos claros y logística eficiente.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-lime-500 mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-white">Transparencia</h4>
                    <p className="text-gray-400">Comunicación honesta y directa.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-lime-500 mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-white">Servicio</h4>
                    <p className="text-gray-400">Tu éxito es nuestro éxito.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative h-[600px] rounded-2xl overflow-hidden border border-lime-500/20">
              <img src="https://public.readdy.ai/ai/img_res/a33992bc998d5b702af3c77105f12652.jpg" alt="Equipo ACI" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </section>

      {/* Contacto Section */}
      <section id="contacto" className="relative py-24 overflow-hidden">
        <div className="absolute inset-0">
          <img src="https://readdy.ai/api/search-image?query=dark-warehouse-interior-with-neon-green-lighting-stacked-boxes-and-products-professional-distribution-center-industrial-space-logistics-facility-dramatic-lighting-cyberpunk-aesthetic&width=1920&height=1080&seq=contacto-bg-energy-001&orientation=landscape" alt="Contacto" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-black/80"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-lime-500/20 via-transparent to-lime-500/20"></div>
        </div>

        <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-black text-white mb-4">
              Comienza a Distribuir con <span className="text-lime-400">ACI</span>
            </h2>
            <p className="text-xl text-gray-300">
              Completa el formulario o escríbenos directo
            </p>
          </div>

          <div className="bg-zinc-900/90 backdrop-blur-sm border border-lime-500/30 rounded-2xl p-8 lg:p-12 shadow-2xl shadow-lime-500/10">
            <form onSubmit={handleFormSubmit} data-readdy-form id="contacto-form">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label htmlFor="nombre" className="block text-sm font-semibold text-lime-400 mb-2">
                    Nombre Completo
                  </label>
                  <input
                    type="text"
                    id="nombre"
                    name="nombre"
                    value={formData.nombre}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 bg-black/50 border border-lime-500/30 rounded-lg focus:ring-2 focus:ring-lime-500 focus:border-transparent outline-none transition-all text-white placeholder-gray-500"
                    placeholder="Tu nombre"
                  />
                </div>
                <div>
                  <label htmlFor="negocio" className="block text-sm font-semibold text-lime-400 mb-2">
                    Nombre del Negocio
                  </label>
                  <input
                    type="text"
                    id="negocio"
                    name="negocio"
                    value={formData.negocio}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 bg-black/50 border border-lime-500/30 rounded-lg focus:ring-2 focus:ring-lime-500 focus:border-transparent outline-none transition-all text-white placeholder-gray-500"
                    placeholder="Nombre de tu negocio"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label htmlFor="comuna" className="block text-sm font-semibold text-lime-400 mb-2">
                    Comuna
                  </label>
                  <input
                    type="text"
                    id="comuna"
                    name="comuna"
                    value={formData.comuna}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 bg-black/50 border border-lime-500/30 rounded-lg focus:ring-2 focus:ring-lime-500 focus:border-transparent outline-none transition-all text-white placeholder-gray-500"
                    placeholder="Tu comuna"
                  />
                </div>
                <div>
                  <label htmlFor="telefono" className="block text-sm font-semibold text-lime-400 mb-2">
                    Teléfono
                  </label>
                  <input
                    type="tel"
                    id="telefono"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 bg-black/50 border border-lime-500/30 rounded-lg focus:ring-2 focus:ring-lime-500 focus:border-transparent outline-none transition-all text-white placeholder-gray-500"
                    placeholder="+56 9 1234 5678"
                  />
                </div>
              </div>

              <div className="mb-6">
                <label htmlFor="email" className="block text-sm font-semibold text-lime-400 mb-2">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 bg-black/50 border border-lime-500/30 rounded-lg focus:ring-2 focus:ring-lime-500 focus:border-transparent outline-none transition-all text-white placeholder-gray-500"
                  placeholder="tu@email.com"
                />
              </div>

              <div className="mb-6">
                <label htmlFor="productos" className="block text-sm font-semibold text-lime-400 mb-2">
                  Productos de Interés
                </label>
                <select
                  id="productos"
                  name="productos"
                  value={formData.productos}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 bg-black/50 border border-lime-500/30 rounded-lg focus:ring-2 focus:ring-lime-500 focus:border-transparent outline-none transition-all text-white"
                >
                  <option value="" className="bg-zinc-900">Selecciona una categoría</option>
                  <option value="Energética Score" className="bg-zinc-900">Energética Score</option>
                  <option value="Bebidas CCU" className="bg-zinc-900">Bebidas CCU</option>
                  <option value="Abarrotes" className="bg-zinc-900">Abarrotes</option>
                  <option value="Higiene" className="bg-zinc-900">Higiene</option>
                  <option value="Todos" className="bg-zinc-900">Todos los productos</option>
                </select>
              </div>

              <div className="mb-6">
                <label htmlFor="volumen" className="block text-sm font-semibold text-lime-400 mb-2">
                  Volumen Estimado / Comentarios
                </label>
                <textarea
                  id="volumen"
                  name="volumen"
                  value={formData.volumen}
                  onChange={handleInputChange}
                  maxLength={500}
                  rows={3}
                  className="w-full px-4 py-3 bg-black/50 border border-lime-500/30 rounded-lg focus:ring-2 focus:ring-lime-500 focus:border-transparent outline-none transition-all resize-none text-white placeholder-gray-500"
                  placeholder="Cuéntanos sobre tu volumen de compra mensual o cualquier consulta..."
                ></textarea>
                <p className="text-xs text-gray-500 mt-1">Máximo 500 caracteres</p>
              </div>

              <button
                type="submit"
                disabled={formStatus === 'sending'}
                className="w-full py-4 bg-lime-500 text-black rounded-lg font-bold text-lg hover:bg-lime-400 transition-colors disabled:bg-gray-600 disabled:cursor-not-allowed whitespace-nowrap shadow-lg shadow-lime-500/30"
              >
                {formStatus === 'sending' ? 'Enviando...' : 'Enviar Solicitud'}
              </button>

              {formStatus === 'success' && (
                <div className="mt-4 p-4 bg-lime-500/20 text-lime-400 rounded-lg text-center border border-lime-500/30">
                  ¡Mensaje enviado! Te contactaremos pronto.
                </div>
              )}

              {formStatus === 'error' && (
                <div className="mt-4 p-4 bg-red-500/20 text-red-400 rounded-lg text-center border border-red-500/30">
                  Hubo un error. Por favor intenta nuevamente.
                </div>
              )}
            </form>

            <div className="mt-8 text-center">
              <p className="text-gray-400 mb-4">O escríbenos por WhatsApp</p>
              <button onClick={handleWhatsApp} className="inline-flex items-center gap-2 px-6 py-3 bg-lime-500 text-black rounded-lg font-bold hover:bg-lime-400 transition-colors whitespace-nowrap">
                <i className="ri-whatsapp-line text-2xl"></i>
                Chatear Ahora
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-zinc-950 border-t border-lime-500/20">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
            <div>
              <h3 className="text-lime-400 font-bold text-lg mb-4 border-b-2 border-lime-500 pb-2 inline-block">Servicios</h3>
              <ul className="space-y-3">
                <li><a href="#servicios" className="text-gray-400 hover:text-lime-400 transition-colors text-sm">Distribución Mayorista</a></li>
                <li><a href="#servicios" className="text-gray-400 hover:text-lime-400 transition-colors text-sm">Abastecimiento Recurrente</a></li>
                <li><a href="#servicios" className="text-gray-400 hover:text-lime-400 transition-colors text-sm">Coordinación de Rutas</a></li>
                <li><a href="#servicios" className="text-gray-400 hover:text-lime-400 transition-colors text-sm">Postventa</a></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lime-400 font-bold text-lg mb-4 border-b-2 border-lime-500 pb-2 inline-block">Productos</h3>
              <ul className="space-y-3">
                <li><a href="#productos" className="text-gray-400 hover:text-lime-400 transition-colors text-sm">Energética Score</a></li>
                <li><a href="#productos" className="text-gray-400 hover:text-lime-400 transition-colors text-sm">Bebidas CCU</a></li>
                <li><a href="#productos" className="text-gray-400 hover:text-lime-400 transition-colors text-sm">Abarrotes</a></li>
                <li><a href="#productos" className="text-gray-400 hover:text-lime-400 transition-colors text-sm">Higiene</a></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lime-400 font-bold text-lg mb-4 border-b-2 border-lime-500 pb-2 inline-block">Empresa</h3>
              <ul className="space-y-3">
                <li><a href="#nosotros" className="text-gray-400 hover:text-lime-400 transition-colors text-sm">Sobre Nosotros</a></li>
                <li><a href="#nosotros" className="text-gray-400 hover:text-lime-400 transition-colors text-sm">Nuestros Valores</a></li>
                <li><a href="#contacto" className="text-gray-400 hover:text-lime-400 transition-colors text-sm">Contacto</a></li>
                <li><a href="#inicio" className="text-gray-400 hover:text-lime-400 transition-colors text-sm">Cobertura</a></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lime-400 font-bold text-lg mb-4 border-b-2 border-lime-500 pb-2 inline-block">Contacto</h3>
              <ul className="space-y-3 text-sm">
                <li className="flex items-start gap-2 text-gray-400">
                  <i className="ri-phone-line mt-1 text-lime-500"></i>
                  <span>+56 9 1234 5678</span>
                </li>
                <li className="flex items-start gap-2 text-gray-400">
                  <i className="ri-mail-line mt-1 text-lime-500"></i>
                  <span>contacto@acidistribucion.cl</span>
                </li>
                <li className="flex items-start gap-2 text-gray-400">
                  <i className="ri-map-pin-line mt-1 text-lime-500"></i>
                  <span>Santiago, Región Metropolitana</span>
                </li>
                <li className="flex items-start gap-2 text-gray-400">
                  <i className="ri-time-line mt-1 text-lime-500"></i>
                  <span>Lun - Vie: 9:00 - 18:00</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-lime-500/20 pt-8">
            <div className="flex flex-col items-center gap-4">
              <div className="text-center">
                <p className="text-gray-400 text-sm">© 2025 Abarca y Castillo Distribución SpA</p>
                <p className="text-gray-600 text-xs mt-1">Todos los derechos reservados</p>
              </div>
            </div>

            <div className="text-center mt-6">
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-600 text-xs hover:text-lime-400 transition-colors">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
